import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import goalValidations from 'scaleflow/validators/goal';
import targetValidations from 'scaleflow/validators/target';
import { Changeset } from 'ember-changeset';

class BusinessGoalsCreateRoute extends Route {
  @service store;

  goalValidator({ key, newValue, oldValue, changes, content }) {
    let validator = get(goalValidations, key);
    if (typeof validator === 'function') {
      return validator(newValue, oldValue, changes, content);
    }
  }

  targetValidator({ key, newValue, oldValue, changes, content }) {
    let validator = get(targetValidations, key);
    if (typeof validator === 'function') {
      return validator(newValue, oldValue, changes, content);
    }
  }

  beforeModel() {
    return Promise.all([
      this.store.findAll('person'),
      this.store.findAll('metric'),
    ]);
  }

  model() {
    return this.store.createRecord('goal');
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const goalChangeset = Changeset(model.changeset_object, this.goalValidator);
    const targetChangesetFactory = () => {
      const target = this.store.createRecord('target', {});
      return Changeset(target, this.targetValidator);
    };

    controller.set('goalChangeset', goalChangeset);
    controller.set('targetChangesetFactory', targetChangesetFactory);
  }

  resetForm(controller) {
    controller.set('activeStep', 0);
    controller.set('targetChangesets', []);
    controller.set('selectedGoals', []);
    controller.set('selectedMetrics', []);
    controller.set('goalSearch', '');
    controller.set('metricSearch', '');
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.resetForm(controller);
    }
  }
}

export default instrumentRoutePerformance(BusinessGoalsCreateRoute);
